(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { gql as e, isApolloError as t, useLazyQuery as n, useMutation as r, useQuery as i } from "@apollo/client";
import { getOperationName as a } from "@apollo/client/utilities";
import { Badge as o, Banner as s, Button as c, FieldText as l, FieldWrapper as u, FlexBox as d, FormField as f, Icon as p, List as m, Modal as h, ModalBody as g, ModalFoot as _, ModalHead as v, Spinner as y, Tag as b, Text as x, Tooltip as S } from "@dixa/lib-shared-habla";
import { colors as C } from "@dixa/lib-shared-tokens";
import { createContext as w, createElement as T, useCallback as E, useContext as ee, useEffect as D, useMemo as te, useState as O } from "react";
import { Fragment as k, jsx as A, jsxs as j } from "react/jsx-runtime";
import { FormProvider as M, useController as ne } from "react-hook-form";
import re from "moment";
import { useInterval as ie } from "react-use";
import ae from "lodash/lowerCase";
import N from "lodash/upperFirst";
import { MockedProvider as oe } from "@apollo/client/testing";
import { render as se } from "@testing-library/react";
import { HookFormText as P } from "lib-shared-hook-form";
import ce from "classnames";
//#region src/apis/widgetConfiguration/queries/widgetConfiguration.query.ts
var F = e`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, I = e`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, L = e`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, R = e`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, z = (e, t) => function(n, r) {
	return i(n, {
		...r,
		context: {
			operationName: a(n),
			...r?.context,
			widgetId: e,
			widgetType: t
		}
	});
}, B = (e, t) => function(r, i) {
	return n(r, {
		...i,
		context: {
			operationName: a(r),
			...i?.context,
			widgetId: e,
			widgetType: t
		}
	});
}, le = (e, t, n) => function(r, i) {
	return n.query({
		query: r,
		variables: i,
		context: {
			operationName: a(r),
			widgetId: e,
			widgetType: t
		}
	});
}, ue = (e, t) => function(n, i) {
	return r(n, {
		...i,
		context: {
			operationName: a(n),
			...i?.context,
			widgetId: e,
			widgetType: t
		}
	});
}, V = ({ error: e }) => e.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", de = ({ errors: e }) => e.some((e) => V({ error: e })), H = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", fe = ({ errors: e }) => e.some((e) => H({ error: e })), U = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", pe = ({ errors: e }) => e.some((e) => U({ error: e })), W = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", me = ({ errors: e }) => e.some((e) => W({ error: e })), G = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", he = ({ errors: e }) => e.some((e) => G({ error: e })), K = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", ge = ({ errors: e }) => e.some((e) => K({ error: e })), q = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", _e = ({ errors: e }) => e.some((e) => q({ error: e })), ve = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", ye = ({ errors: e }) => e.some((e) => ve({ error: e })), be = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", xe = ({ errors: e }) => e.some((e) => be({ error: e })), Se = ({ error: e }) => e.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", Ce = ({ errors: e }) => e.some((e) => Se({ error: e })), we = (e) => {
	let { delay: t = 2e3 } = e || {}, [n, r] = O(!1);
	return D(() => {
		let e = n ? window.setTimeout(() => r(!1), t) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copy: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}, J = {
	errorWrapper: "_errorWrapper_171rr_1",
	copyIcon: "_copyIcon_171rr_5"
}, Te = ({ error: e, retry: n, isMisconfigured: r = !1, hideCopyButton: i = !1 }) => {
	let a = e && t(e) && e?.graphQLErrors?.length > 0, { isCopied: o, copy: l } = we(), u = /* @__PURE__ */ A(p, {
		color: C.red[500],
		size: 16,
		name: "exclamation-triangle-filled"
	});
	if (r || a && Ce({ errors: e.graphQLErrors })) return /* @__PURE__ */ j(d, {
		margin: "0 0 100",
		padding: "200",
		className: J.errorWrapper,
		children: [/* @__PURE__ */ A(d, {
			margin: "0 300 0 0",
			alignItems: "center",
			children: u
		}), /* @__PURE__ */ A(x.Paragraph, {
			color: "secondary",
			children: "This integration is not properly configured and could not be loaded. Please contact your administrator."
		})]
	});
	if (!a) return /* @__PURE__ */ A(d, {
		margin: "200 0",
		flexDirection: "column",
		children: /* @__PURE__ */ A(m.Item, {
			contentLeft: u,
			title: "Something went wrong. Please try again later.",
			variant: "dense"
		})
	});
	let f = e?.graphQLErrors || [];
	return /* @__PURE__ */ j(d, {
		margin: "200 0 300",
		flexDirection: "column",
		className: J.errorWrapper,
		children: [f.map((t, n) => {
			let r = t?.extensions?.integration, i = r?.message || e?.message || "No error message available", a = r?.responseBody && JSON.parse(r?.responseBody), o = a?.errorMessages || [], s = a?.warningMessages || [], c = [...o, ...s].join(" ");
			return /* @__PURE__ */ A(m.Item, {
				title: i,
				titleSecondary: c,
				contentLeft: u
			}, n);
		}), !i && /* @__PURE__ */ j(d, {
			margin: "200 0 300",
			flexDirection: "column",
			gap: "200",
			children: [/* @__PURE__ */ A(s, {
				variant: "info",
				description: /* @__PURE__ */ A(x.Paragraph, {
					variant: "4",
					children: "Please copy the error details by clicking on the button below and include them in your support request."
				})
			}), /* @__PURE__ */ j(d, {
				flexDirection: "row",
				gap: "200",
				justifyContent: "space-between",
				children: [n && /* @__PURE__ */ A(c, {
					variant: "secondary",
					icon: "sync",
					onClick: () => n(),
					children: "Retry"
				}), /* @__PURE__ */ A(c, {
					variant: "secondary",
					icon: o ? "done" : "copy",
					onClick: () => l(JSON.stringify(f, null, 2)),
					className: J.copyIcon,
					children: "Copy error payload"
				})]
			})]
		})]
	});
}, Ee = ({ headline: e, text: t, children: n, onConfirm: r, onCancel: i, confirmLabel: a, cancelLabel: o = "Cancel", confirmVariant: s = "primary", cancelVariant: c = "secondary", isOpen: l, setIsOpen: u, showOnClose: d = !1 }) => /* @__PURE__ */ j(h, {
	isOpen: l,
	onClose: () => {
		i && i(), u(!1);
	},
	children: [
		/* @__PURE__ */ A(v, {
			title: e,
			onClose: d ? i : void 0
		}),
		/* @__PURE__ */ j(g, { children: [t && /* @__PURE__ */ A("div", {
			style: { width: "600px" },
			children: t
		}), n] }),
		/* @__PURE__ */ A(_, {
			confirmOnClick: r ? () => {
				r(), u(!1);
			} : void 0,
			cancelOnClick: () => {
				i && i(), u(!1);
			},
			confirmName: a,
			cancelName: o,
			confirmProps: { variant: s },
			cancelProps: { variant: c }
		})
	]
}), De = "The configuration of the integration is not correct. Please check the settings.", Oe = ({ cause: e }) => /* @__PURE__ */ A(d, {
	margin: "0 0 400",
	children: /* @__PURE__ */ A(s, {
		variant: "fail",
		headline: "This integration is misconfigured",
		description: /* @__PURE__ */ j(d, {
			gap: "300",
			flexDirection: "column",
			children: [/* @__PURE__ */ A(x.Paragraph, { children: e || "The configuration of the integration is not correct. Please check the settings." }), /* @__PURE__ */ j(d, {
				flexDirection: "column",
				gap: "100",
				children: [/* @__PURE__ */ A(x.Heading, {
					variant: "heading-3",
					children: "Additional information"
				}), /* @__PURE__ */ A(x.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })]
			})]
		})
	})
}), ke = ({ form: e, integrationId: t, onValidSubmit: n, error: r, onRetry: i, isLoading: a, isWidgetUnknown: o, children: s }) => r ? /* @__PURE__ */ A(Te, {
	error: r,
	retry: i
}) : a ? /* @__PURE__ */ A(y, { "data-testid": "widget-settings-loading" }) : o ? /* @__PURE__ */ j(x.Paragraph, { children: [
	"A widget with the id ",
	/* @__PURE__ */ A(b, { children: t }),
	" does not exist."
] }) : /* @__PURE__ */ A(M, {
	...e,
	children: /* @__PURE__ */ A("form", {
		noValidate: !0,
		tabIndex: -1,
		"data-testid": `widget-settings-form-${t ?? "create-new"}`,
		onSubmit: e.handleSubmit(n),
		children: s
	})
}), Ae = re, je = ae, Me = N;
//#endregion
//#region src/utils/common.ts
function Ne(e, t = !0) {
	try {
		return JSON.parse(JSON.stringify(e));
	} catch {
		return t && console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
	}
}
var Pe = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, Fe = (e) => {
	let t = je(e);
	return t.length === 0 ? e : Me(t);
}, Ie = "DD MMM YYYY @ HH:mm";
function Le(e, t) {
	return e == null ? t : typeof e == "boolean" ? e : e === "true";
}
function Re(e, t) {
	return e == null ? t : String(e);
}
//#endregion
//#region src/utils/countryCodes.ts
function ze(e) {
	try {
		return new Intl.DisplayNames(["en"], { type: "region" }).of(e.toUpperCase()) ?? e;
	} catch {
		return e;
	}
}
var Be = /* @__PURE__ */ "AF.AX.AL.DZ.AD.AO.AI.AG.AR.AM.AW.AC.AU.AT.AZ.BS.BH.BD.BB.BY.BE.BZ.BJ.BM.BT.BO.BA.BW.BV.BR.IO.BN.BG.BF.BI.KH.CA.CV.BQ.KY.CF.TD.CL.CN.CX.CC.CO.KM.CG.CD.CK.CR.HR.CU.CW.CY.CZ.CI.DK.DJ.DM.DO.EC.EG.SV.GQ.ER.EE.SZ.ET.FK.FO.FJ.FI.FR.GF.PF.TF.GA.GM.GE.DE.GH.GI.GR.GL.GD.GP.GT.GG.GN.GW.GY.HT.HM.VA.HN.HK.HU.IS.IN.ID.IR.IQ.IE.IM.IL.IT.JM.JP.JE.JO.KZ.KE.KI.KP.XK.KW.KG.LA.LV.LB.LS.LR.LY.LI.LT.LU.MO.MG.MW.MY.MV.ML.MT.MQ.MR.MU.YT.MX.MD.MC.MN.ME.MS.MA.MZ.MM.NA.NR.NP.NL.AN.NC.NZ.NI.NE.NG.NU.NF.MK.NO.OM.PK.PS.PA.PG.PY.PE.PH.PN.PL.PT.QA.CM.RE.RO.RU.RW.BL.SH.KN.LC.MF.PM.WS.SM.ST.SA.SN.RS.SC.SL.SG.SX.SK.SI.SB.SO.ZA.GS.KR.SS.ES.LK.VC.SD.SR.SJ.SE.CH.SY.TW.TJ.TZ.TH.TL.TG.TK.TO.TT.TA.TN.TR.TM.TC.TV.UG.UA.AE.GB.US.UM.UY.UZ.VU.VE.VN.VG.WF.EH.YE.ZM.ZW.ZZ".split("."), Ve = (e) => {
	if (!e?.trim()) return "Please add a valid subdomain";
	let t = ["https://", "http://"].find((t) => e.startsWith(t)), n = t ? `Please remove the protocol \`${t}\` from the hostname` : "", r = e.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
	if (!t && e.includes("@")) return "Please remove the `@` from the hostname";
	if (/\s/.test(e)) return "Please remove the spaces from the hostname";
	if (n && r) return `Please remove the protocol \`${t}\` and the trailing \`/\` from the hostname`;
	if (n) return n;
	if (r) return r;
};
//#endregion
//#region src/utils/jwt.ts
function He(e) {
	let t = e.split(".")[1];
	if (!t) throw Error("Invalid token");
	let n = t.replace(/-/g, "+").replace(/_/g, "/");
	try {
		return JSON.parse(atob(n).toString());
	} catch (e) {
		throw Error(`Failed to parse the JSON Web Token with the following error: ${e}`);
	}
}
//#endregion
//#region src/hooks/useInboundOAuthContext/useInboundOAuthContext.ts
var Y = w(null);
function Ue() {
	let e = ee(Y);
	if (e === null) throw Error("useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider");
	return e;
}
//#endregion
//#region src/hooks/useInboundOAuthContext/useInboundOAuthContext.utils.test.ts
function We() {
	return {
		isInboundOAuth: !1,
		setIsInboundOAuth: () => {},
		hasTriggeredAuthorization: !1,
		setHasTriggeredAuthorization: () => {}
	};
}
//#endregion
//#region src/hooks/useWidgetContext/useWidgetContext.ts
var Ge = w(null), Ke = Ge.Provider;
function qe() {
	let e = ee(Ge);
	if (e === null) throw Error("useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider");
	return e;
}
//#endregion
//#region src/utils/testing.ts
function Je() {
	window._partner = { events: { emit: () => {} } };
}
var Ye = {
	useMutation: r,
	useQuery: () => ({
		data: void 0,
		loading: !1,
		error: void 0
	}),
	useLazyQuery: () => [() => {}, { loading: !1 }],
	executeQuery: () => {},
	showNotification: () => {},
	showModal: () => {}
}, Xe = { baseUrl: "http://localhost/graphql" };
function Ze(e, { mocks: t = [], overrides: n = {} } = {}) {
	let r = vi.fn(), i = vi.fn(), a = {
		configuration: Xe,
		handleRedirect: r,
		showNotification: i,
		featureFlags: {
			shopifySalesAttribution: !1,
			sidebarConditions: !1
		},
		...n
	};
	return {
		...se(T(oe, { mocks: t }, T(Y.Provider, { value: We() }, T(Ke, { value: Ye }, T(e, a))))),
		handleRedirect: r,
		showNotification: i
	};
}
function Qe({ id: e, configuration: t }) {
	let n = t?.settings ?? [];
	return {
		request: {
			query: F,
			variables: { id: e }
		},
		result: { data: { Management: { widgetConfigurations: [{
			id: e,
			type: t?.type ?? "UNKNOWN",
			name: t?.name ?? "Test widget",
			enabled: t?.enabled ?? !0,
			misconfigured: t?.misconfigured ?? !1,
			misconfigurationCause: t?.misconfigurationCause ?? null,
			additionalProperties: t?.additionalProperties ?? null,
			settings: n
		}] } } }
	};
}
function $e({ variables: e, result: t }) {
	return {
		request: {
			query: L,
			variables: e
		},
		result: { data: { Management: { createWidgetConfiguration: {
			id: t?.id ?? "new-id",
			name: t?.name ?? e.name,
			enabled: t?.enabled ?? e.enabled,
			misconfigured: t?.misconfigured ?? !1,
			misconfigurationCause: t?.misconfigurationCause ?? null,
			additionalProperties: t?.additionalProperties ?? null,
			settings: t?.settings ?? []
		} } } }
	};
}
function et({ variables: e, result: t }) {
	return {
		request: {
			query: I,
			variables: e
		},
		result: { data: { Management: { updateWidgetConfiguration: {
			id: e.id,
			name: t?.name ?? e.name,
			enabled: t?.enabled ?? e.enabled ?? !0,
			misconfigured: t?.misconfigured ?? !1,
			misconfigurationCause: t?.misconfigurationCause ?? null,
			additionalProperties: t?.additionalProperties ?? null,
			settings: t?.settings ?? []
		} } } }
	};
}
function tt({ id: e }) {
	return {
		request: {
			query: R,
			variables: { id: e }
		},
		result: { data: { Management: { deleteWidgetConfiguration: { id: e } } } }
	};
}
//#endregion
//#region src/utils/widgetSettingsConversion/widgetSettingsConversion.ts
function nt(e, t) {
	let n = {};
	for (let r of t) {
		let t = e.find((e) => e.key === r.key)?.value;
		r.secret && t === void 0 || (r.type === "boolean" ? n[r.key] = Le(t, r.defaultValue) : n[r.key] = Re(t, r.defaultValue));
	}
	return n;
}
function rt(e, t) {
	return t.filter((t) => e[t.key] !== void 0).map((t) => ({
		key: t.key,
		value: String(e[t.key]),
		secret: t.secret
	}));
}
//#endregion
//#region src/utils/widgetSettingsConversion/widgetSettingsConversion.utils.ts
function it(e) {
	return Object.fromEntries(e.map((e) => [e.key, e.label]));
}
async function at(e, { fieldDefinitions: t, isCreationMode: n, create: r, update: i }) {
	let a = rt(e, t), o = {
		name: e.name,
		enabled: e.enabled,
		settings: a
	};
	n ? await r(o) : await i(o);
}
//#endregion
//#region src/helpers/dev-helper.ts
function ot(e) {
	let { user_id: t, iss: n } = He(e);
	return {
		"x-integration-user-id": t,
		"x-integration-organization-id": n
	};
}
function st(e) {
	return e.startsWith("http://localhost");
}
//#endregion
//#region src/hooks/useInboundOAuthContext/inboundOAuthContextProvider.tsx
var ct = ({ children: e }) => {
	let [t, n] = O(!1), [r, i] = O(!1), a = te(() => ({
		isInboundOAuth: t,
		setIsInboundOAuth: n,
		hasTriggeredAuthorization: r,
		setHasTriggeredAuthorization: i
	}), [t, r]);
	return /* @__PURE__ */ A(Y.Provider, {
		value: a,
		children: e
	});
};
//#endregion
//#region src/hooks/useTracking/useTracking.ts
function X() {
	return { track: (e, t) => window._partner.events.emit(e, t) };
}
//#endregion
//#region src/components/oAuth/oAuthSettings.tsx
var Z = (e) => {
	switch (e) {
		case "CONNECTED": return {
			icon: "check-circle-filled",
			color: C.green[500],
			tooltip: "Connected"
		};
		case "CONNECTING": return {
			icon: "sync",
			color: C.neutral[500],
			tooltip: "Connecting.."
		};
		case "CONNECTION_FAILED": return {
			icon: "close-circle-filled",
			color: C.red[500],
			tooltip: "Connection failed"
		};
		case "CONNECTION_TIMEOUT": return {
			icon: "exclamation-triangle-filled",
			color: C.red[200],
			tooltip: "Connection timeout"
		};
		default: return {
			icon: "exclamation-circle-filled",
			color: C.neutral[500],
			tooltip: "Not connected"
		};
	}
}, lt = ({ configuration: e, integrationId: t, integrationType: n, label: r }) => {
	let [i, a] = O("CONNECTING"), [o, s] = O(""), [l, m] = O(null), { track: h } = X(), { icon: g, color: _, tooltip: v } = Z(i), [b, C] = O({}), [w, T] = O(0), [E, ee] = O(2e3), [te, M] = O(!1), [ne, re] = O(3), { isInboundOAuth: ae, setIsInboundOAuth: N, hasTriggeredAuthorization: oe, setHasTriggeredAuthorization: se } = Ue(), { baseUrl: P } = e, ce = `${P}/auth/connect/${n.toLowerCase()}/${t}`, F = `${P}/auth/status/${n.toLowerCase()}/${t}`, I = i === "CONNECTING", L = (e) => Object.keys(e).length === 0, R = () => {
		M(!1), T(0);
	};
	D(() => {
		let e = localStorage.getItem("authData");
		if (e) {
			let t = JSON.parse(e ?? "{}").access_token;
			C({
				method: "GET",
				headers: {
					"content-type": "application/json",
					authorization: `Bearer ${t}`,
					...st(P) && ot(t)
				}
			});
		}
	}, [P]), D(() => {
		L(b) || M(!0);
	}, [b]);
	let z = () => {
		re(15), fetch(F, { ...b }).then((e) => e.json()).then(({ data: e }) => {
			let { status: r, createdAt: i, createdByName: o } = e;
			switch (r) {
				case "CONNECTING":
					a("CONNECTING");
					break;
				case "CONNECTED":
					if (h("settings:view:oauth:succeeded", {
						widgetId: t,
						widgetType: n
					}), a("CONNECTED"), i && o) {
						let e = new Date(i);
						isNaN(e.getTime()) || m(e), s(o);
					}
					R();
					break;
				case "NOT_CONNECTED":
				case "CONNECTION_FAILED": a(r), R();
			}
		}).catch((e) => {
			console.warn(`Fetching OAuth status failed for ${n} ${t}`, e), a("CONNECTION_FAILED");
		});
	};
	ie(() => {
		w >= ne ? (a("CONNECTION_TIMEOUT"), R()) : (z(), T(w + 1));
	}, te ? E : null);
	let B = () => {
		h("settings:view:oauth:started", {
			widgetId: t,
			widgetType: n
		}), fetch(ce, { ...b }).then((e) => e.json()).then(({ data: e }) => {
			let { url: t } = e, n = window.innerWidth / 2 - 620 / 2, r = window.innerHeight / 2 - 800 / 2;
			a("CONNECTING"), M(!0), window.open(t, "DixaPartnerOAuth", `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=620,
						height=800,
						left=${n},
						top=${r}`);
		}).catch((e) => {
			console.warn(`Fetching OAuth connection failed for ${n} ${t}`, e), a("CONNECTION_FAILED");
		});
	};
	return D(() => {
		ae && !oe && !L(b) && (se(!0), N(!1), B());
	}, [b]), /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A(f, {
		span: 3,
		children: /* @__PURE__ */ A(u, {
			label: r,
			meta: { warning: "All agents interact with the widget using your access permissions." },
			style: { marginBottom: 20 },
			children: /* @__PURE__ */ j(d, {
				flexDirection: "row",
				alignItems: "baseline",
				gap: "300",
				children: [/* @__PURE__ */ A(c, {
					icon: "key",
					variant: "secondary",
					onClick: B,
					disabled: I,
					style: { marginBottom: 8 },
					children: "Start authorization"
				}), /* @__PURE__ */ A(S, {
					content: v,
					children: I ? /* @__PURE__ */ A(y, {
						"data-testid": "oauth-button-spinner",
						size: 18
					}) : /* @__PURE__ */ j(d, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ A(p, {
							"data-testid": "oauth-button-status-icon",
							name: g,
							color: _
						}), i === "CONNECTED" && o && l && /* @__PURE__ */ j(x.Paragraph, {
							variant: "4",
							subdued: !0,
							children: [
								"Authorized by ",
								o,
								" at",
								" ",
								Ae(l).format("DD MMM YYYY @ HH:mm")
							]
						})]
					})
				})]
			})
		})
	}), /* @__PURE__ */ A(f, { span: 3 })] });
}, ut = ({ value: e }) => /* @__PURE__ */ A(p, {
	name: e ? "check-circle-filled" : "close-circle-filled",
	color: e ? C.green[500] : C.red[500],
	size: 14,
	"data-testid": `displayAttributeValue-icon-${e ? "true" : "false"}`
}), dt = ({ value: e }) => /* @__PURE__ */ A(x.Paragraph, {
	variant: "5",
	color: "secondary",
	align: "right",
	children: e.join(", ")
}), ft = ({ value: e }) => /* @__PURE__ */ A(o, {
	variant: "success",
	size: "small",
	children: e
}), pt = ({ value: e }) => {
	let t = e.replace("days_ago: ", ""), n = t.startsWith("-"), r = t === "0", i = n ? `${t.replace("-", "")} days ago` : `in ${t} days`;
	return /* @__PURE__ */ A(x.Paragraph, {
		variant: "5",
		color: "secondary",
		children: r ? "today" : i
	});
}, mt = ({ value: e }) => /* @__PURE__ */ A(x.Paragraph, {
	variant: "5",
	color: "secondary",
	children: e.format(Ie)
}), Q = ({ value: e }) => /* @__PURE__ */ A(o, {
	variant: "info",
	size: "small",
	children: e
}), ht = (e, t) => {
	if (e == null) return null;
	if (t === "string") return /* @__PURE__ */ A(Q, { value: e.toString() });
	if (Array.isArray(e)) return /* @__PURE__ */ A(dt, { value: e });
	if (typeof e == "boolean" || e === "true" || e === "false") return /* @__PURE__ */ A(ut, { value: e === "true" || e === !0 });
	if (typeof e == "number" || /^\d*\.?\d+$/.test(e)) return /* @__PURE__ */ A(ft, { value: e });
	if (e.startsWith("days_ago: ")) return /* @__PURE__ */ A(pt, { value: e });
	let n = Ae(e);
	return n.isValid() ? /* @__PURE__ */ A(mt, { value: n }) : /* @__PURE__ */ A(Q, { value: e });
}, gt = (e) => {
	let { isCreationMode: t = !1, label: n, helpIcon: r, name: i } = e, [a, o] = O(t);
	if (!a) {
		let e = typeof n == "string" ? n : "";
		return /* @__PURE__ */ A(u, {
			label: n,
			helpIcon: r,
			children: /* @__PURE__ */ j(c, {
				"data-testid": `secret-field-button-${i}`,
				variant: "secondary",
				icon: "pen",
				onClick: () => o(!0),
				children: ["Update ", e]
			})
		});
	}
	return /* @__PURE__ */ A(_t, {
		...e,
		isCreationMode: t,
		onClose: () => o(!1)
	});
}, _t = (e) => {
	let { isCreationMode: t, componentProps: n, onClose: r } = e, i = {
		...n,
		prefix: t ? n?.prefix : {
			type: "button",
			button: {
				icon: "close",
				onClick: r
			}
		}
	};
	return /* @__PURE__ */ A(P, {
		...e,
		componentProps: i,
		shouldUnregister: !0
	});
}, $ = {
	wrapper: "_wrapper_1lmim_1",
	wrapperBox: "_wrapperBox_1lmim_4",
	wrapperBoxErrorBorder: "_wrapperBoxErrorBorder_1lmim_9"
}, vt = (e, t) => e !== "" && t !== "" ? window.btoa(`${e}:${t}`) : "", yt = (e) => {
	let { isCreationMode: t = !1, label: n, name: r } = e, [i, a] = O(t);
	if (!i) {
		let e = typeof n == "string" ? n : "";
		return /* @__PURE__ */ A(u, {
			label: n,
			children: /* @__PURE__ */ j(c, {
				"data-testid": `secret-field-button-${r}`,
				variant: "secondary",
				icon: "pen",
				onClick: () => a(!0),
				children: ["Update ", e]
			})
		});
	}
	return /* @__PURE__ */ A(bt, {
		...e,
		isCreationMode: t,
		onClose: () => a(!1)
	});
}, bt = (e) => {
	let { name: t, control: n, label: r, rules: i, isCreationMode: a, usernameLabel: o, passwordLabel: s, usernamePlaceholder: c, passwordPlaceholder: f, onClose: p } = e, { field: m, fieldState: h } = ne({
		name: t,
		control: n,
		rules: i,
		shouldUnregister: !0
	}), [g, _] = O(""), [v, y] = O(""), b = (e) => {
		_(e), m.onChange(vt(e, v));
	}, x = (e) => {
		y(e), m.onChange(vt(g, e));
	}, S = !!i?.required;
	return /* @__PURE__ */ A(u, {
		label: r,
		required: S,
		meta: {
			touched: h.isTouched,
			error: h.error?.message
		},
		className: $.wrapper,
		children: /* @__PURE__ */ j(d, {
			gap: "300",
			flexDirection: "column",
			className: ce($.wrapperBox, { [$.wrapperBoxErrorBorder]: !!h.error }),
			children: [/* @__PURE__ */ A(l, {
				noAlert: !0,
				required: S,
				label: o,
				placeholder: c,
				input: {
					name: t,
					value: g,
					onChange: (e) => b(e?.target.value ?? ""),
					onBlur: m.onBlur
				},
				...!a && { prefix: {
					type: "button",
					button: {
						icon: "close",
						onClick: p
					}
				} }
			}), /* @__PURE__ */ A(l, {
				noAlert: !0,
				required: S,
				label: s,
				placeholder: f,
				input: {
					name: t,
					value: v,
					onChange: (e) => x(e?.target.value ?? ""),
					onBlur: m.onBlur
				},
				...!a && { prefix: {
					type: "button",
					button: {
						icon: "close",
						onClick: p
					}
				} }
			})]
		})
	});
}, xt = {
	submit: "Submit",
	delete: "Delete",
	confirmDelete: "Yes",
	cancelDelete: "No"
}, St = ({ integrationType: e, integrationId: t, widgetName: n, isCreationMode: r, isSubmitting: i, automationCouplingState: a, onConfirmDelete: o, labels: s, deleteConfirmationBody: l, confirmDeleteVariant: u = "primary" }) => {
	let { track: f } = X(), [p, m] = O(!1), h = {
		...xt,
		...s
	}, g = !a || !a.isCoupled;
	return /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ j(d, {
		margin: "300 0 0 0",
		children: [/* @__PURE__ */ A(c, {
			type: "submit",
			isLoading: i,
			disabled: i,
			children: h.submit
		}), !r && /* @__PURE__ */ A(S, {
			content: "The widget is used in automations",
			disabled: g,
			children: /* @__PURE__ */ A(c, {
				style: { marginLeft: 20 },
				icon: "trash",
				variant: "secondary",
				type: "button",
				onClick: () => {
					t && f("settings:view:delete:requested", {
						widgetId: t,
						widgetType: e
					}), m(!0);
				},
				disabled: !g,
				isLoading: a?.isLoading,
				children: h.delete
			})
		})]
	}), /* @__PURE__ */ A(Ee, {
		isOpen: p,
		setIsOpen: m,
		confirmVariant: u,
		confirmLabel: h.confirmDelete,
		cancelLabel: h.cancelDelete,
		onCancel: () => {
			t && f("settings:view:delete:canceled", {
				widgetId: t,
				widgetType: e
			});
		},
		onConfirm: o,
		children: /* @__PURE__ */ A(d, { children: l ?? /* @__PURE__ */ j(k, { children: [
			"Are you sure you want to delete the ",
			e,
			" integration \"",
			n,
			"\"?"
		] }) })
	})] });
}, Ct = { shopifySalesAttribution: "partner-integrations-shopify-sales-attribution" }, wt = e`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Tt = e`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Et(e) {
	let { useQuery: t, useMutation: n } = qe(), [r, i] = O(), [a, o] = O(), [s, c] = O(!1), { loading: l, data: u, error: d } = t(wt, {
		skip: !e,
		variables: { conversationId: e?.toString() }
	}), [f, { loading: p, error: m }] = n(Tt);
	return D(() => {
		!l && u && i(u?.Storage?.widgetData ?? {});
	}, [u, l]), D(() => d && o(d), [d]), D(() => c(l), [l]), D(() => m && o(m), [m]), D(() => c(p), [p]), {
		data: r,
		loading: s,
		store: async (t, n) => await f({ variables: {
			conversationId: (n ?? e)?.toString(),
			data: t
		} }).then(({ data: e }) => i(e?.Storage?.storeWidgetData?.data ?? {})),
		error: a
	};
}
//#endregion
//#region src/hooks/useWidgetSettingsMutations/useWidgetSettingsMutations.ts
var Dt = ({ integrationId: e, integrationType: t, handleRedirect: n, showNotification: i }) => {
	let { track: a } = X(), [o, s] = O(!1), [c, l] = O(), [u, d] = O(null), f = E((e) => (t) => {
		l(t), s(!1), i({
			title: "Something went wrong",
			text: `The ${e} of the widget was not successful.`,
			icon: "exclamation-triangle-filled",
			severity: "warning"
		});
	}, [i]), [p] = r(L, { onError: f("creation") }), [m] = r(I, { onError: f("update") }), [h] = r(R, { onError: f("deletion") });
	return {
		create: E(async ({ name: e, enabled: r, settings: o }) => {
			a("settings:create:submitted", { widgetType: t }), s(!0), l(void 0);
			let { data: c } = await p({ variables: {
				type: t,
				name: e,
				enabled: r,
				settings: o
			} });
			s(!1);
			let u = c?.Management?.createWidgetConfiguration;
			if (!u) {
				i({
					title: "Something went wrong",
					text: "The creation of the widget was not successful.",
					icon: "exclamation-triangle-filled",
					severity: "warning"
				});
				return;
			}
			i({
				title: "Creating was successful",
				text: "Creating the widget was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}), n(u.id);
		}, [
			p,
			n,
			t,
			i,
			a
		]),
		update: E(async ({ name: n, enabled: r, settings: o }) => {
			if (!e) return;
			a("settings:view:change:submitted", {
				widgetId: e,
				widgetType: t
			}), s(!0), l(void 0);
			let { data: c } = await m({ variables: {
				id: e,
				name: n,
				enabled: r,
				settings: o
			} });
			s(!1);
			let u = c?.Management?.updateWidgetConfiguration;
			if (!u) {
				i({
					title: "Something went wrong",
					text: "The update of the widget was not successful.",
					icon: "exclamation-triangle-filled",
					severity: "warning"
				});
				return;
			}
			u.misconfigured ? d(u.misconfigurationCause ?? "The configuration of the integration is not correct. Please check the settings.") : d(null), i({
				title: "Updating was successful",
				text: "Updating the widget was successful.",
				icon: "check-circle-filled",
				severity: "success"
			});
		}, [
			e,
			t,
			i,
			a,
			m
		]),
		remove: E(async () => {
			if (!e) return;
			a("settings:view:delete:confirmed", {
				widgetId: e,
				widgetType: t
			}), s(!0), l(void 0);
			let { data: r } = await h({ variables: { id: e } });
			s(!1), r?.Management?.deleteWidgetConfiguration && (n(), i({
				title: "Deletion was successful",
				text: "The deletion of the widget was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}));
		}, [
			h,
			n,
			e,
			t,
			i,
			a
		]),
		isLoading: o,
		error: c,
		misconfigurationCause: u,
		setMisconfigurationCause: d
	};
};
//#endregion
//#region src/hooks/useWidgetSettingsQuery/useWidgetSettingsQuery.ts
function Ot({ integrationId: e, fieldDefinitions: t, form: n, onMisconfigured: r }) {
	let [a, o] = O(!1), [s, c] = O(), { loading: l, error: u, refetch: d } = i(F, {
		variables: { id: e },
		skip: !e,
		onCompleted: (e) => {
			let i = e?.Management?.widgetConfigurations?.[0];
			if (!i) {
				o(!0), c(void 0);
				return;
			}
			o(!1), c(i), n.reset({
				...nt(i.settings ?? [], t),
				enabled: !!i.enabled,
				name: i.name
			}), i.misconfigured && r?.(i.misconfigurationCause ?? "The configuration of the integration is not correct. Please check the settings.");
		}
	});
	return D(() => {
		o(!1), c(void 0);
	}, [e]), {
		isLoading: l,
		error: u,
		isWidgetUnknown: a,
		refetch: d,
		widgetConfiguration: s
	};
}
//#endregion
export { ut as DisplayAttributeBoolean, mt as DisplayAttributeDate, pt as DisplayAttributeDaysAgo, ft as DisplayAttributeNumber, Q as DisplayAttributeString, dt as DisplayAttributeStringArray, Te as DisplayErrors, Y as InboundOAuthContext, ct as InboundOAuthContextProvider, Ee as IntegrationModal, Oe as MisconfigurationBanner, lt as OAuthSettings, yt as PartnerHookFormBasicAuth, gt as PartnerHookFormSecretText, ke as PartnerSettingsWrapper, Ke as WidgetContextProvider, St as WidgetSettingsFormFooter, Pe as capitalizeFirstCharacter, Be as countryCodes, We as createMockInboundOAuthContextOptions, $e as createWidgetConfigurationCreateMock, tt as createWidgetConfigurationDeleteMock, L as createWidgetConfigurationMutation, Qe as createWidgetConfigurationQueryMock, et as createWidgetConfigurationUpdateMock, Ne as deepClone, Ie as defaultDateFormat, De as defaultMisconfigurationCause, Xe as defaultPartnerSettingsConfiguration, Ye as defaultWidgetContextValue, R as deleteWidgetConfigurationMutation, ht as displayAttributeValue, rt as formValuesToSettings, Z as getConnectionStatusValues, ze as getCountryNameFromCountryCode, ot as getPartnerDevApiHeaders, F as getWidgetConfigurationByIdQuery, at as handleWidgetSubmit, de as hasDixaHeaderCheckError, fe as hasDownstreamApiAuthorizationError, _e as hasDownstreamApiBadRequestError, ge as hasDownstreamApiConflictError, ye as hasDownstreamApiForbiddenError, he as hasDownstreamApiNotFoundError, pe as hasDownstreamApiPermissionError, me as hasDownstreamApiServiceUnavailableError, xe as hasDownstreamApiTooManyRequestsError, Ce as hasWidgetMisconfiguredError, Fe as humanizeKey, V as isDixaHeaderCheckError, H as isDownstreamApiAuthorizationError, q as isDownstreamApiBadRequestError, K as isDownstreamApiConflictError, ve as isDownstreamApiForbiddenError, G as isDownstreamApiNotFoundError, U as isDownstreamApiPermissionError, W as isDownstreamApiServiceUnavailableError, be as isDownstreamApiTooManyRequestsError, st as isRunningLocalPartnerApi, Se as isWidgetMisconfiguredError, le as makeExecuteQuery, B as makeUseLazyQuery, ue as makeUseMutation, z as makeUseQuery, it as mapLabels, He as parseAccessToken, Le as parseBoolean, Re as parseString, Ct as partnerFeatureNameToFlagMapping, Ze as renderPartnerSettings, nt as settingsToFormValues, Je as stubPartnerEventsBusForTests, I as updateWidgetConfigurationMutation, we as useCopyWithDelay, Et as useData, Ue as useInboundOAuthContext, X as useTracking, qe as useWidgetContext, Dt as useWidgetSettingsMutations, Ot as useWidgetSettingsQuery, Ve as validateApiHostName };
